export type TenantPortalStatus = 'active' | 'invited' | 'invite_expired' | 'not_invited';

export function resolveTenantPortalStatus(t: {
  portal_password_hash?: string | null;
  portal_active?: boolean;
  portal_invited?: boolean;
  portal_status?: TenantPortalStatus;
}): TenantPortalStatus {
  if (t.portal_status) return t.portal_status;
  if (t.portal_active || t.portal_password_hash) return 'active';
  if (t.portal_invited) return 'invited';
  return 'not_invited';
}

export function portalInviteButtonLabel(status: TenantPortalStatus, inviting = false): string {
  if (inviting) return 'Sending…';
  switch (status) {
    case 'active': return '✅ Portal active';
    case 'invited': return '📨 Invited — resend';
    case 'invite_expired': return '📨 Resend invite';
    default: return '📨 Invite portal';
  }
}

export function portalStatusBadge(status: TenantPortalStatus): { label: string; bg: string; color: string } {
  switch (status) {
    case 'active': return { label: 'Portal active', bg: '#dcfce7', color: '#166534' };
    case 'invited': return { label: 'Invite sent', bg: '#dbeafe', color: '#1d4ed8' };
    case 'invite_expired': return { label: 'Invite expired', bg: '#ffedd5', color: '#c2410c' };
    default: return { label: 'Not invited', bg: '#f1f5f9', color: '#64748b' };
  }
}
